import React from 'react';
import Spinner from 'react-spinkit';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ReferenceLine
} from 'recharts';

const OperatorsChartBadgeComponent = ({ name, data, is_loading }) => {

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length > 0) {
      return (
        <div className="custom-tooltip">
          <p className="label">{label}</p>
          <br />
          <p className="label">{payload[0].value}</p>
        </div>
      );
    } else {
      return null;
    }
  }

  return <div className='cards-badge-profit-chart' >
    <div className='cards-badge-header'>
      <p>{name}</p>
    </div>

    <div className='cards-badge-body'>
      {is_loading ? (
          <div
            className='spinner-loading'
            style={{ paddingTop: '15px', paddingBottom: '65px', textAlign: 'center' }}
          >
            <Spinner name='folding-cube' fadeIn='none' />
          </div>
      ) : (
        <>
          <BarChart
            width={800}
            height={250}
            data={data}
            margin={{
              top: 5,
              right: 0,
              left: 5,
              bottom: 5,
            }}
          >
            <XAxis
              dataKey="name"
              angle={-35}
              textAnchor="end"
              tick={{ fontSize: 9, fill: "#fff" }} />
            <YAxis tick={{ fontSize: 16, fill: "#fff" }} />
            <Tooltip content={<CustomTooltip />} />
            <Legend />
            <ReferenceLine y={0} stroke="#000" />
            <Bar dataKey="total" fill="#82ca9d" />
          </BarChart>
        </>
      )}
    </div>
  </div>;
};

export default OperatorsChartBadgeComponent;